import { DOOR_COST_REPORT_PAGE_TYPE } from 'features/summary-report/suppliers/door-cost/types';
import { CREW_MEMBER_DETAIL_TAB } from 'modules/EBusiness/CrewManagement/CrewMemerProfileDetailPage/constants';

const publicPaths = {
  loginPage: (redirectedFrom?: string) =>
    `/auth/login${redirectedFrom ? `?redirectedFrom=${redirectedFrom}` : ''}`,
  keycloakAuthenticationPage: () => `/auth/keycloak-authentication`,
};

const privatePaths = {
  portalPage: () => '/',

  /** Administrator */
  roleManagementPage: () => '/system/administrator/role-management',
  accountManagementPage: () => '/system/administrator/account-management',
  accessControlManagementPage: () =>
    '/system/administrator/access-control-management',

  /** Summary Report */
  suppliersDoorCostSummaryReportPage: (
    reportType: DOOR_COST_REPORT_PAGE_TYPE,
    queryParams?: string
  ) =>
    `/summary-report/suppliers/door-cost/${reportType}${queryParams ? `?${queryParams}` : ''}`,

  /** E-Business */
  containerRepairOrdersPage: () =>
    `/e-business/container-management/repair-orders`,
  containerRepairOrderDetailPage: (orderId: string) =>
    `/e-business/container-management/repair-orders/${orderId}`,
  containerRepairQuotationSheetsPage: () =>
    `/e-business/container-management/repair-quotation-sheets`,
  quotationListPage: () => '/e-business/ebl/quotation',
  quotationDetailPage: (quotationId: string) =>
    `/e-business/ebl/quotation/${quotationId}`,
  billOfLandingPage: () => '/e-business/ebl/bill-of-lading',
  doorCostPage: () => `/e-business/suppliers-management/door-cost`,
  doorCostDetailPage: (doorCostId: string) =>
    `/e-business/suppliers-management/door-cost/detail/${doorCostId}`,
  crewMemberProfilesManagementPage: () =>
    `/e-business/crew-members-management/profiles`,
  crewMemberProfileDetailPage: (
    crewMemberId: string,
    sectionId: CREW_MEMBER_DETAIL_TAB
  ) =>
    `/e-business/crew-members-management/detail/${crewMemberId}/${sectionId}`,
  availableCrewMembersListPage: () =>
    `/e-business/crew-members-management/available`,
  onLeaveCrewMembersListPage: () =>
    `/e-business/crew-members-management/on-leave`,
};

const pathsMap = {
  ...publicPaths,
  ...privatePaths,
};

export type PathsMap = typeof pathsMap;

export const getPath = <TRoute extends keyof PathsMap>(
  route: TRoute,
  ...params: Parameters<PathsMap[TRoute]>
) => {
  const pathCb: (...args: any[]) => string = pathsMap[route];
  return pathCb(...params);
};
